<ng-container *ngIf="!isMobile; else mobileCorrespondence">
    <div class="table-list__container" *ngIf="correspondence.correspondentiestuk.length < 2">
        <div class="table-list__item">{{ correspondence.pg_datum | dateFormat }}</div>
        <div class="table-list__item">{{ correspondence.onderwerp }}</div>
        <div class="table-list__item">{{ correspondence.afzender_naam }}</div>
        <div class="table-list__item">{{ correspondence.pg_partij }}</div>
        <div class="table-list__item">
            <span class="table-list__downloads" #correspondenceDownloadsRef>
                <span class="table-list__download-item" *ngIf="correspondence.correspondentiestuk.length > 0">
                    <ins-download
                        [downloadLinkRef]="correspondenceDownloadsRef"
                        [documentId]="correspondence.correspondentiestuk[0].cynodocs_document_id"
                    ></ins-download>
                </span>
                <span>
                    {{ correspondence.correspondentiestuk.length }}
                    document
                </span>
            </span>
        </div>
    </div>

    <div class="table-list__container" (click)="toggleRow()" *ngIf="correspondence.correspondentiestuk.length > 1">
        <div class="table-list__item">{{ correspondence.pg_datum | dateFormat }}</div>
        <div class="table-list__item">{{ correspondence.onderwerp }}</div>
        <div class="table-list__item">{{ correspondence.afzender_naam }}</div>
        <div class="table-list__item">{{ correspondence.pg_partij }}</div>
        <div class="table-list__item">
            <span class="table-list__downloads table-list__downloads--multiple">
                <svg *ngIf="!row" class="svg-icon svg-icon--xs">
                    <use href="assets/icons-ui.svg#pijl-down-bold"></use>
                </svg>
                <svg *ngIf="row" class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#pijl-up-bold"></use></svg>
                <span>{{ correspondence.correspondentiestuk.length }} documenten</span>
            </span>
            <ul class="table-list__list" [ngClass]="getToggleState()">
                <li
                    class="table-list__list-item"
                    #downloadItemRef
                    *ngFor="let bijlage of correspondence.correspondentiestuk"
                >
                    <div class="table-list__download-item" *ngIf="correspondence.correspondentiestuk.length > 0">
                        <ins-download
                            [downloadLinkRef]="downloadItemRef"
                            [documentId]="bijlage.cynodocs_document_id"
                        ></ins-download>
                    </div>
                    {{ bijlage.document_omschrijving }}
                </li>
            </ul>
        </div>
    </div>
</ng-container>

<ng-template #mobileCorrespondence>
    <div class="table-list__mobile">
        <div
            class="table-list__mobile-container"
            [ngClass]="{
                'table-list-container--open': isOpen,
                'table-list__mobile-container--init': correspondenceIndex === 0 && isOpen
            }"
        >
            <div class="table-list__mobile-item">
                <span class="table-list__item-title table-list__item-title--icon" (click)="toggle()">
                    <span>Bericht {{ correspondenceIndex + 1 }}</span>
                    <span>
                        <ng-container *ngIf="isOpen">
                            <div class="correspondence__icon">
                                <svg class="svg-icon svg-icon--xs">
                                    <use href="assets/icons-ui.svg#pijl-down-bold"></use>
                                </svg>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="!isOpen">
                            <div class="correspondence__icon">
                                <svg class="svg-icon svg-icon--xs">
                                    <use href="assets/icons-ui.svg#pijl-up-bold"></use>
                                </svg>
                            </div>
                        </ng-container>
                    </span>
                </span>
                <span class="table-list__item-value">{{ correspondence.onderwerp }}</span>
            </div>
            <div class="table-list__mobile-item">
                <span class="table-list__item-title">Datum</span>
                <span class="table-list__item-value">{{ correspondence.pg_datum | dateFormat }}</span>
            </div>
            <div class="table-list__mobile-item">
                <span class="table-list__item-title">Van</span>
                <span class="table-list__item-value">{{ correspondence.afzender_naam }}</span>
            </div>
            <div class="table-list__mobile-item">
                <span class="table-list__item-title">Aan</span>
                <span class="table-list__item-value">{{ correspondence.pg_partij }}</span>
            </div>

            <div class="table-list__mobile-item">
                <span class="table-list__item-title">Bijlage</span>
                <ul class="table-list__list table-list__list--mobile">
                    <li
                        class="table-list__list-item"
                        #downloadItemRef
                        *ngFor="let bijlage of correspondence.correspondentiestuk"
                    >
                        <div class="table-list__download-item" *ngIf="correspondence.correspondentiestuk.length > 0">
                            <ins-download
                                [downloadLinkRef]="downloadItemRef"
                                [documentId]="bijlage.cynodocs_document_id"
                            ></ins-download>
                        </div>
                        {{ bijlage.document_omschrijving }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</ng-template>
